<template>
  <b-container v-if="!this.loading" class="pl-0 pr-0 pt-0 pb-0">
    <b-card>
      <h4>Scoring Event</h4>
      <b-row v-if="!skip.programme" class="text-left pt-2">
        <b-col>
          <b-form-group 
            id="programmesGroup" 
            :horizontal="horizontal"
            :label-cols="2" 
            breakpoint="md"
            :label="`Programme${multiple.programme ? '(s)' : ''}`"
            label-for="programmes"
          >
            <multiselect 
              id="programmes"
              v-model="programmes" 
              :options="programmeList" 
              :multiple="multiple.programme" 
              :close-on-select="!multiple.programme" 
              :placeholder="'All'" 
              track-by="id" 
              label="name" 
              :select-label="''" 
              :deselect-label="''"
              @input="function(value) { $emit('update:programme', value); }"/>    
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="!skip.year" class="text-left pt-2">
        <b-col>
          <b-form-group 
            id="yearsGroup" 
            :horizontal="horizontal"
            :label-cols="2" 
            breakpoint="md"
            :label="`Year${multiple.year ? '(s)' : ''}`"
            label-for="years"
          >
            <multiselect 
              id="years"
              v-model="years" 
              :options="yearList" 
              :multiple="multiple.year" 
              :close-on-select="!multiple.year" 
              :placeholder="'All'" 
              :select-label="''" 
              :deselect-label="''"
              @input="function(value) { $emit('update:year', value); }"/>    
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="!skip.customer" class="text-left pt-2">
        <b-col>
          <b-form-group 
            id="customersGroup" 
            :horizontal="horizontal"
            :label-cols="2" 
            breakpoint="md"
            :label="`Customer${multiple.customer ? '(s)' : ''}`"
            label-for="customers"
          >
            <multiselect 
              id="customers"
              v-model="customers" 
              :options="customerList" 
              :multiple="multiple.customer" 
              :close-on-select="!multiple.customer" 
              :placeholder="'All'" 
              track-by="id" 
              label="name" 
              :select-label="''" 
              :deselect-label="''"
              @input="function(value) { $emit('update:customer', value); }"/>    
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="!skip.industry" class="text-left pt-2">
        <b-col>
          <b-form-group 
            id="industriesGroup" 
            :horizontal="horizontal"
            :label-cols="2" 
            breakpoint="md"
            :label="`Industry${multiple.industry ? '(s)' : ''}`"
            label-for="industries"
          >
            <multiselect 
              id="industries"
              v-model="industries" 
              :options="industryList" 
              :multiple="multiple.industry" 
              :close-on-select="!multiple.industry" 
              :placeholder="'All'" 
              :select-label="''" 
              :deselect-label="''"
              @input="function(value) { $emit('update:industry', value); }"/>   
          </b-form-group>
        </b-col> 
      </b-row>
      <b-row v-if="!skip.country" class="text-left pt-2">
        <b-col>
          <b-form-group 
            id="countriesGroup" 
            :horizontal="horizontal"
            :label-cols="2" 
            breakpoint="md"
            :label="`Country${multiple.country ? '(s)' : ''}`"
            label-for="countries"
          >
            <multiselect 
              id="countries"
              v-model="countries" 
              :options="countryList" 
              :multiple="multiple.country" 
              :close-on-select="!multiple.country" 
              :placeholder="'All'" 
              :select-label="''" 
              :deselect-label="''"
              @input="function(value) { $emit('update:country', value); }"/>    
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="!skip.region" class="text-left pt-2">
        <b-col>
          <b-form-group 
            id="regionsGroup" 
            :horizontal="horizontal"
            :label-cols="2" 
            breakpoint="md"
            :label="`Region${multiple.region ? '(s)' : ''}`"
            label-for="regions"
          >
            <multiselect 
              id="regions"
              v-model="regions" 
              :options="regionList" 
              :multiple="multiple.region" 
              :close-on-select="!multiple.region" 
              :placeholder="'All'" 
              :select-label="''" 
              :deselect-label="''"
              group-values="regions" 
              group-label="country" 
              :group-select="true"
              @input="function(value) { $emit('update:region', value); }"/>    
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="!skip.gear" class="text-left pt-2">
        <b-col>
          <b-form-group 
            id="gearsGroup" 
            :horizontal="horizontal"
            :label-cols="2" 
            breakpoint="md"
            :label="`Gear${multiple.gear ? '(s)' : ''}`"
            label-for="gears"
          >
            <multiselect 
              id="gears"
              v-model="gears" 
              :options="gearList" 
              :multiple="multiple.gear" 
              :close-on-select="!multiple.gear" 
              :placeholder="'All'" 
              :select-label="''" 
              :deselect-label="''"
              @input="function(value) { $emit('update:gear', value); }"/>    
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
  </b-container>
  <b-row v-else>
    <font-awesome-icon icon="spinner" size="lg" spin/>
  </b-row>
</template>
<script>
// @ is an alias to /src
import {industries, gearDef, countries, regions} from '@/services/constants';
import * as _ from 'lodash';
import * as API from '@/services/API';

export default {
  name: "ScoringEventSearch",
  props: {
    skip: {
      default: {},
      type: Object
    },
    multiple: {
      default: {},
      type: Object
    },
    horizontal: {
      default: false,
      type: Boolean
    }
  },
  watch: {
    // limit regions to country
    country: function(val) {
      this.regionList = this.getRegions(val);
    }
  },
  created () {
    // init fairly static lists.
    this.industryList = _.clone(industries);
    this.industryList.unshift('');
    this.countryList = _.clone(countries);
    this.countryList.unshift('');
    const thisYear = new Date().getFullYear();
    for(let i = 2011; i <= thisYear; i++) {
      this.yearList.unshift(i);
    }
    this.yearList.unshift('');
    this.regionList = this.getRegions(null);
    this.gearList = Object.values(gearDef);
    
    // dynamic data
    return Promise.all([
      API.getCustomers().then(results => this.customerList = results.results),
      API.getProgrammes().then(results => this.programmeList = results.results)
    ]).then(() => { this.loading = false; });
  },
  data: function() {
    return {
      programmes: null,
      programmeList: [],
      years: null,
      yearList: [],
      customers: null,
      customerList: [],
      industries: null,
      industryList: [],
      countries: null,
      countryList: [],
      regions: null,
      regionList: [],
      gears: null,
      gearList: [],
      loading: true
    }
  },
  methods: {
    getRegions(newCountry) {
      return Object.keys(regions).map((country) => {
        return {
          country,
          regions: regions[country]
        };
      }).filter(x => (!newCountry || newCountry === x.country));
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ScoringEventSearch.vue